module.exports = __webpack_public_path__ + "img/20.871c72c9.jpg";